import React from 'react'
import {CardHeader,Button} from 'reactstrap'
import PropTypes from 'prop-types'


const defaultProps={
    hasSetting:false,
    hasRightIcon:true,
    className:'',
    rightIcon:'',
}

const propTypes={
    hasSetting:PropTypes.bool,
    hasRightIcon:PropTypes.bool,
    rightIcon:PropTypes.string,
    className:PropTypes.string,
    children:PropTypes.node,
    onSettingClick:PropTypes.func
}

const excardHeader=(props)=>{
debugger;
        let {className, hasSetting,hasRightIcon,rightIcon}=props;

        
        if (hasRightIcon)
            rightIcon=rightIcon===''?<i className="fa fa-align-justify"></i>:<i className={rightIcon}></i>

        const actionElement= <div className="card-header-actions">
                                    {
                                        hasSetting
                                            ?<Button color="link" className="card-header-action btn-setting" onClick={props.onSettingClick}><i className="icon-settings"></i></Button>
                                            :null
                                    }
                            </div>

        return <CardHeader className={className}>
                    {rightIcon}
                    {props.children}
                    {actionElement}
                </CardHeader>
    }

    excardHeader.propTypes=propTypes;
    excardHeader.defaultProps=defaultProps;


export default excardHeader;